export const sortInvitees = (invitees) => invitees.sort((inviteeA, inviteeB) => inviteeA.full_name.localeCompare(inviteeB.full_name))
